export enum ProductField {
  PRODUCT_NAME = 'PRODUCT_NAME',
  INSURANCE_PLAN = 'INSURANCE_PLAN',
  INSURANCE_PREMIUM = 'INSURANCE_PREMIUM',
  PAYMENT_TERM = 'PAYMENT_TERM',
  PAYMENT_FREQUENCY = 'PAYMENT_FREQUENCY',
  EFFECTIVE_DATE = 'EFFECTIVE_DATE',
  PAYMENT_YEAR = 'PAYMENT_YEAR',
  RIDER_COUNT = 'RIDER_COUNT',
}

export enum MasterDataFormMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export type MasterDataSettingItem = {
  _id: string;
  name: ProductField;
  createdAt?: Date;
  updatedAt?: Date;
  updatedBy?: string;
};

export type MasterDataSettingValueItem = {
  _id: string;
  value: string;
};

export type MasterDataSettingListItem = {
  _id: string;
  masterDataName: ProductField;
  values: MasterDataSettingValueItem[];
  createdAt: Date;
  updatedAt: Date;
  updatedBy: string;
};

/**
 * Validation config per master data name.
 * - type: 'text' allows any string, 'number' allows only numeric input
 * - maxLength: max characters allowed
 */
export const MASTER_DATA_VALIDATION: Record<ProductField, { type: 'text' | 'number'; maxLength?: number }> = {
  [ProductField.PRODUCT_NAME]: { type: 'text', maxLength: 100 },
  [ProductField.INSURANCE_PLAN]: { type: 'text', maxLength: 100 },
  [ProductField.INSURANCE_PREMIUM]: { type: 'text', maxLength: 100 },
  [ProductField.PAYMENT_TERM]: { type: 'text', maxLength: 100 },
  [ProductField.PAYMENT_FREQUENCY]: { type: 'text', maxLength: 100 },
  [ProductField.EFFECTIVE_DATE]: { type: 'text', maxLength: 100 },
  [ProductField.PAYMENT_YEAR]: { type: 'text', maxLength: 100 },
  [ProductField.RIDER_COUNT]: { type: 'text', maxLength: 100 },
};

export const MAX_VALUES_PER_CREATION = 100;
export const MAX_VALUES_PER_MASTER_DATA = MAX_VALUES_PER_CREATION;
